module.exports = __webpack_public_path__ + "img/x13.d9a8ea7d.jpg";